module.exports = __webpack_public_path__ + "assets/img/thumb-Kent-Street-Cellars-1-Video.f69ded4a.webp";